import { useSelector } from 'react-redux';
import { useGetAnnouncementQuery } from '../slices/announcementApiSlice';
import { selectUser } from '../slices/auth';
import { UserRoles } from '../utils/constants';
import { CiEdit } from 'react-icons/ci';
import { useNavigate } from 'react-router';

const DashboardAnnouncement = () => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const { data, isLoading, error } = useGetAnnouncementQuery('');
  if (isLoading) return <div>Loading...</div>;
  if (!data?.length || data[0].content === '')
    return user.roles === UserRoles.Admin ? (
      <div
        className='bg-white shadow-md rounded-md p-4 mb-4 border border-gray-300'
        onClick={() => {
          navigate('announcement/edit');
        }}
      >
        <span className='flex flex-row items-center gap-2'>
          <h2 className='text-lg font-semibold'>Announcement</h2>
          <CiEdit />
        </span>
      </div>
    ) : (
      <></>
    );
  return (
    <div
      className={`shadow-md rounded-md p-4 mb-4 border border-gray-300 ${
        user.roles === UserRoles.Admin ? 'cursor-pointer' : ''
      }`}
      onClick={() => {
        if (user.roles === UserRoles.Admin) navigate('announcement/edit');
      }}
    >
      <span className='flex flex-row justify-between items-center gap-2'>
        <div className='flex flex-row items-center gap-2'>
          <h2 className='text-lg font-semibold'>Announcement</h2>
          {user.roles === UserRoles.Admin && <CiEdit />}
        </div>
        {data?.[0]?.updated_at && (
          <p className='text-sm text-gray-500'>
            Last updated:{' '}
            {new Date(data[0].updated_at).toLocaleString('en-US', {
              month: 'long',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            })}
          </p>
        )}
      </span>
      <p className='text-gray-600 whitespace-pre-line'>{data?.[0]?.content}</p>
    </div>
  );
};

export default DashboardAnnouncement;
